import React, { Component } from 'react';

function fixedZero(val) {
  return val < 10 ? `0${val}` : val;
}

class CountDown extends Component {
  timer = 0;
  interval = 1000;

  constructor(props) {
    super(props);
    this.state = {
      lastTime: props.seconds,
    };
  }

  componentDidMount() {
    this.tick();
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  tick = () => {
    const { onEnd } = this.props;
    let { lastTime } = this.state;

    this.timer = setTimeout(() => {
      if (lastTime <= 1) { // 倒计时结束条件
        clearTimeout(this.timer); // 倒计时结束，清除定时器
        this.setState({ lastTime: 0 }, () => {
          if (onEnd) {
            onEnd();
          }
        });
      } else {
        lastTime -= 1;
        this.setState({ lastTime }, this.tick);
      }
    }, this.interval);
  };

  // 格式化显示时间
  formatTime = (time) => {
    return <span className="color-count-down">{fixedZero(time)} s</span>;
  };

  render() {
    const { lastTime } = this.state;
    return <span className="color-count-down">{this.formatTime(lastTime)}</span>;
  }
}

export default CountDown;
